<div id="properties">
    <span class="label faded property">{{label}}</span>
    <ng-container *ngIf="properties.length > 0 && showCategory">
        <span class="label faded category">Category
            <span class="warn" *ngIf="!allSitesHaveCategory()">
                <mat-icon>error_outline</mat-icon>
                <span class="message">
                    Category cannot be empty. Please select at least one category for each site.
                </span>
            </span>
        </span>
        <span class="label faded permalink">{{assignment.published ? 'Permalink' : 'Slug'}}</span>
    </ng-container>
    <div class="faded placeholder" *ngIf="!canEdit && properties.length == 0">No Properties Added</div>
    <div class="sites">
        <div *ngFor="let site of properties; let i = index; trackBy: utils.trackByIndex" fxLayout="row" fxLayoutGap="10px">
            <span class="property">
                <a 
                    href="{{site?.permalink}}" 
                    title="{{site.domain}}"
                    target="_blank" 
                    class="site-{{site.abbreviation}}"
                    [ngClass]="{primary: site.primary, faded: site.status == 'draft'}">
                        {{site.abbreviation}}
                </a>
                <button *ngIf="site.blog_id == 14" class="faded" [attr.title]="'Edit taxonomies'" (click)="openTaxOptions()">
                    <mat-icon>edit</mat-icon>
                    <span class="warn" *ngIf="site.blog_id == 14 && !hasPATaxonomies()">
                        <mat-icon>error_outline</mat-icon>
                        <span class="message">
                            Please select taxonomies for PastFactory.
                        </span>
                    </span>
                </button>
            </span>
            <site-category 
                *ngIf="showCategory"
                #siteCategory
                class="category"
                [primaryCats]="primaryCategories"
                [canEdit]="canEdit"
                [(site)]="properties[i]"
                (siteChanged)="updateSiteCategories($event)">
            </site-category>
            <span>
                <a 
                    [ngClass]="{faded: site.status == 'draft'}"
                    *ngIf="site.permalink"
                    href="{{site.permalink}}" 
                    target="_blank">{{site.samplePermalink ? site.samplePermalink : site.permalink}}
                </a>
                <span 
                    [ngClass]="{faded: true}"
                    *ngIf="!site.permalink && (site.desiredSlug || site.slug)">
                    {{site.desiredSlug ? site.desiredSlug : site.slug}}
                </span>
            </span>
            <span class="actions">
                <mat-icon 
                    title="Edit slug"
                    *ngIf="canEdit && editSlug"
                    (click)="openEditSlug(site)" 
                    class="faded edit">
                    edit
                </mat-icon>
                <mat-icon 
                    title="Set to draft"
                    *ngIf="site.newStatus == 'draft' || !site.newStatus && site.status == 'draft'"
                    (click)="openEditMeta(site)"
                    class="warning edit">
                    error_outline
                </mat-icon>
                <span *ngIf="showMeta">
                    <mat-checkbox 
                        (change)="hidePost(site, $event.checked)" 
                        [disabled]="!canEdit || !editMeta" 
                        [checked]="isChecked(site)" 
                        [indeterminate]="isIndeterminate(site)"> Hide 
                    </mat-checkbox>
                </span>
                <mat-icon
                    *ngIf="showMeta"
                    title="Edit settings" 
                    (click)="openEditMeta(site)" 
                    class="faded">
                    settings
                </mat-icon>
                <mat-icon 
                    title="Remove site"
                    *ngIf="!site.permalink && canEdit && (limited === false || options.length > 1)"
                    (click)="removeSite(i)" 
                    class="faded remove">
                    highlight_off
                </mat-icon>
            </span>
        </div>
    </div>
    <!-- dropdown -->
    <div class="dropdown" #dropdown *ngIf="canEdit && options.length > 1">
        <button 
            class="add-site faded trigger" 
            (click)="openSiteSelect(siteSearch)">
            <mat-icon class="add">add</mat-icon> 
            <input 
                #siteSearch
                type="search" 
                placeholder="{{properties.length > 0 ? 'New clone' : 'Add Property'}}" 
                [(ngModel)]="siteSearchText" 
                (focus)="togglePanel(true)"
                name="propertiesDropdown"
                autocomplete="propertiesDropdown"
                id="propertiesDropdown{{inputRand}}"
            />
        </button>
        <div class="options-panel" id="site-select" [ngClass]="{'open': panelOpen}">
            <ul class="options">
                <li *ngFor="let option of (options | siteSearch: siteSearchText) | hasSite: properties; trackBy: utils.trackByIndex" (click)="addSite(option)">
                    <a class="site-{{option.abbreviation}}">
                        {{option.abbreviation}}
                    </a> 
                    <span>{{option.domain}}</span>
                </li>
            </ul>
        </div>
    </div>
</div>